<template>
  <div class="draw-share-box">
    <canvas class="draw-help" id="shareCanvas" width="1242" height="2208"></canvas>
    <div class="draw-help" id="qrcode"></div>
    <div class="draw-share align jus">
      <van-loading v-if="!imgSrc" />
      <img v-else :src="imgSrc" alt="" class="share-img-detail" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgSrc: ''
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      // 获取分享地址
      this.$get({
        road: 'operationsEventsCheckIn',
        data: {
          id: this.$route.query.operationsEventsId || 7
        },
        params: { userDistributionId: this.$route.query.userDistributionId || 990000 },
        version: 'v2'
      }).then(res => {
        this.$store.commit('WRITECOURSEINFO', res);
        this.drawCanvas(res);
      });
    },
    drawCanvas(distribution) {
      let { avatar, nickName, qrCode } = distribution.options.position;
      $('#qrcode').qrcode({ width: 150, height: 150, text: distribution.distributionLink });
      const canvas1 = document.getElementById('shareCanvas');
      const canvas2 = document.getElementsByTagName('canvas')[1];
      const ctx1 = canvas1.getContext('2d');
      this.$get({ road: 'wxUser', params: { needInfo: 1 }, version: 'v3' }).then(res => {
        Promise.all([this.getImage(distribution.url), this.getImage(res.avatar)]).then(
          images => {
            ctx1.drawImage(images[0], 0, 0, 1242, 2208);
            this.circleImg(ctx1, images[1], avatar.left, avatar.top, avatar.extendWidth / 2);
            ctx1.drawImage(canvas2, qrCode.left, qrCode.top, qrCode.width, qrCode.width);
            ctx1.font = '40px Arial';
            ctx1.fillText(res.nickName, nickName.left, nickName.top + 40);
            setTimeout(() => {
              this.imgSrc = canvas1.toDataURL('image/png');
            }, 100);
          }
        );
      });
    },
    circleImg(ctx, img, x, y, r) {
      ctx.save();
      const d = 2 * r;
      const cx = x + r;
      const cy = y + r;
      ctx.beginPath();
      ctx.arc(cx, cy, r, 0, 2 * Math.PI);
      ctx.clip();
      ctx.drawImage(img, x, y, d, d);
      ctx.restore();
    },
    getImage(src) {
      let image = new Image();
      image.setAttribute('crossorigin', 'anonymous');
      image.src = src;
      return new Promise((resolve) => {
        image.onload = () => {
          resolve(image);
        };
      });
    }
  }
};
</script>

<style lang="less" scoped>
.draw-share-box {
  width: 100vw;

  .draw-help {
    position: fixed;
    left: -2000px;
    top: -1000px;
  }

  #qrcode {
    width: 150px;
    height: 150px;
  }

  .draw-share {
    width: 5.76rem;
    height: 10.24rem;
    margin: 0 auto;

    .share-img-detail {
      width: 5.76rem;
      height: 10.24rem;
    }
  }
}
</style>
